import { render, staticRenderFns } from "./HeadlineCarousel.vue?vue&type=template&id=e3138cda&scoped=true&"
import script from "./HeadlineCarousel.vue?vue&type=script&lang=ts&"
export * from "./HeadlineCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./HeadlineCarousel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HeadlineCarousel.vue?vue&type=style&index=1&id=e3138cda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3138cda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCarousel,VCarouselItem,VCol,VContainer,VImg,VRow})
